import axiosInstance from "../../../../app/myAxiosInstance";
const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

/**
 * Method to get all pms renewal works
 * @param {Object} data 
 */
async function getAllPMSRenewalWorks(data) {
  try {
    const result = await axiosInstance.get(`${baseApiUrl}admin/pmsRenewalWorks`, { params: data });
    return result;
  } catch (err) {
    console.error('error in getAllPMSRenewalWorks ', err);
  }

}

/**
 * Method to get PMS Renewal Work By Id
 * @param {Number} id 
 */
async function getPMSRenewalWorkById(id) {
  try {
    const result = await axiosInstance.get(`${baseApiUrl}admin/pmsRenewalWorks/${id}`);
    return result;
  } catch (err) {
    console.error('error in getAllPMSRenewalWorkById ', err);
  }

}

/**
 * Method to renew pms subscription
 * @param {Number} id 
 * @param {Object} values 
 */
async function renewPMSSubscription(id, values) {
  try {

    const result = await axiosInstance.post(`${baseApiUrl}admin/pmsRenewalWorks/${id}/renewPmsSubscription`, values);
    return result;
  } catch (err) {
    console.error('error in renewPMSSubscription ', err);
  }
}


/**
 * Method to discontinue pms subscription
 * @param {Number} id 
 * @param {Object} values 
 */
async function discontinuePMSSubscription(id, values) {
  try {
    const result = await axiosInstance.patch(`${baseApiUrl}admin/pmsRenewalWorks/${id}/discontinuePmsSubscription`, values);
    return result;
  } catch (err) {
    console.error('error in discontinuePMSSubscription ', err);
  }
}

async function notifyCustomer(id, values) {
  try {
    const result = await axiosInstance.patch(`${baseApiUrl}admin/pmsRenewalWorks/${id}/update`, values);
    return result;
  } catch (err) {
    console.error('error in Notify ', err);
  }
}

/**
 * Method to create PMS Proposal
 * @param {Object} values 
 */
async function createPMSProposal(values) {
  try {

    const result = await axiosInstance.post(`${baseApiUrl}admin/pmsProposals`, values);
    return result;
  } catch (err) {
    console.error('error in createPMSProposal ', err);
  }
}

/**
 * Method to Resend Last PMS Proposal
 * @param {Object} values 
 */
async function resendLastPMSProposal(id) {
  try {

    const result = await axiosInstance.post(`${baseApiUrl}admin/pmsProposals/${id}/resend`);
    return result;
  } catch (err) {
    console.error('error in resendigPMSProposal ', err);
  }
}

async function markRenewalAsMoveOut(id, values) {
  try {

    const result = await axiosInstance.patch(`${baseApiUrl}admin/pmsRenewalWorks/${id}/markMoveOutRenewal`, values);
    return result;
  } catch (err) {
    console.error('error in marking renewal as move-out ', err);
  }
}
export const pmsRenewalServices = {
  getAllPMSRenewalWorks,
  getPMSRenewalWorkById,
  renewPMSSubscription,
  discontinuePMSSubscription,
  notifyCustomer,
  createPMSProposal,
  markRenewalAsMoveOut,
  resendLastPMSProposal
};